/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import {Formik, useFormik} from 'formik';
import {
    Box,
    Button,
    Chip,
    FormHelperText,
    IconButton,
    SvgIcon,
    TextField,
    Typography,
    CardHeader,
    Divider,
    CardContent,
    CircularProgress,
    Grid,
    Checkbox,
    Link,
    Card,
    Avatar,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
    useSt,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Autocomplete from '@mui/material/Autocomplete';
import {Plus as PlusIcon, Star as StarIcon} from 'react-feather';
import { Alert } from '@mui/material';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import {Link as RouterLink} from "react-router-dom";
import axios from "../../../utils/axios";

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
    }
}));

const validationShape = {
    subscriberType: Yup.string()
};

function BulkUploadOptions({
                               enquiryType,
                               stepName,
                               enquiry,
                               onBack,
                               onNext,
                               onChangeEnquiry,
                               onChangeSubscriberType
                           }) {
    const classes = useStyles();
    const [isAlertVisible, setAlertVisible] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: enquiry,
        validationSchema: Yup.object().shape(validationShape),
        onSubmit: (values, {
            resetForm,
            setErrors,
            setStatus,
            setSubmitting,
        }) => {
            if(values.subscriberType == '') {
                values.subscriberType = undefined;
            }

            axios.post('/web/ui/bulkUser/updateBulkUserEnquiry', values).then(response => {
                if(response.data) {
                    setStatus({success: true});
                    //setSubmitting(false);
                    if (onChangeEnquiry) {
                        onChangeEnquiry(values);
                    }
                    if (onNext) {
                        onNext();
                    }

                    if(onChangeSubscriberType) {
                        onChangeSubscriberType(values.subscriberType);
                    }
                } else {
                    setErrors({submit: 'Error contact details'});
                    setStatus({success: false});
                    setSubmitting(false);
                }
            }).catch(error => {
                setErrors({submit: error.message});
                setStatus({success: false});
                setSubmitting(false);
            });
        }
    });

    return (
        <Card>
            <CardHeader title={enquiryType.title + " - " + stepName} titleTypographyProps={{variant: 'h5', color: 'secondary'}}/>
            <Divider/>
            <CardContent>
                {isAlertVisible && formik.errors.schoolInfo != undefined && (
                    <Box mb={3}>
                        <Alert
                            onClose={() => setAlertVisible(false)}
                            severity="info"
                        >
                            {formik.errors.schoolInfo}
                        </Alert>
                    </Box>
                )}
                {formik.isSubmitting || isLoading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        my={5}
                    >
                        <CircularProgress/>
                    </Box>
                ) : (
                    <form onSubmit={formik.handleSubmit}>
                        <Box
                            mx="auto"
                        >
                            <Box mt={1}>
                                <Typography
                                    variant="subtitle1"
                                    color="textSecondary"
                                >
                                    Please let us know what you would like to do.
                                </Typography>
                            </Box>
                            <Box mt={1}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    Who would you like to create accounts for?
                                </Typography>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <RadioGroup row aria-label="subscriberType" name="subscriberType" value={formik.values.subscriberType || ''} onChange={formik.handleChange}>
                                        <FormControlLabel value="STUDENT" control={<Radio />} label="Students" />
                                        <FormControlLabel value="TEACHER" control={<Radio />} label="Teachers" />
                                        {true && (
                                            <FormControlLabel value="" control={<Radio />} label="Students and Teachers" />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Box
                                alignItems="center"
                                display="flex"
                                mt={2}
                                ml={-1}
                            >
                                <Checkbox
                                    checked={formik.values.trial}
                                    name="trial"
                                    onChange={formik.handleChange}
                                />
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    Is this request for a trial?
                                </Typography>
                            </Box>
                            <Box
                                alignItems="center"
                                display="flex"
                                mt={2}
                                ml={-1}
                            >
                                <Checkbox
                                    checked={formik.values.clearClasses}
                                    name="clearClasses"
                                    onChange={formik.handleChange}
                                />
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    Would you like us to clear out your existing classes?
                                </Typography>
                            </Box>
                            {enquiry.importUserType == 'BOOKSELLER' && enquiry.booksellerSchoolId == 239843 && (
                                <Box alignItems="center" display="flex" mt={2} ml={-1}>
                                    <Checkbox
                                        checked={formik.values.sso}
                                        name="sso"
                                        onChange={formik.handleChange}
                                    />
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        Enable Single Sign on
                                    </Typography>
                                </Box>
                            )}
                            <Box mt={2}>
                                <TextField
                                    error={Boolean(formik.touched.enquiryText && formik.errors.enquiryText)}
                                    fullWidth
                                    helperText={formik.touched.enquiryText && formik.errors.enquiryText}
                                    label="Additional notes"
                                    name="enquiryText"
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    value={formik.values.enquiryText}
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                />
                            </Box>
                        </Box>
                        <Box
                            mt={6}
                            display="flex"
                        >
                            <Button
                                onClick={() => {setLoading(true); onBack();}}
                                size="large"
                                color="secondary"
                                variant="contained"
                            >
                                Previous
                            </Button>
                            <Box flexGrow={1}/>
                            <Button
                                color="secondary"
                                disabled={formik.isSubmitting}
                                type="submit"
                                variant="contained"
                                size="large"
                            >
                                Next
                            </Button>
                        </Box>
                    </form>
                )}
            </CardContent>
        </Card>
    );
}

BulkUploadOptions.propTypes = {
    enquiryType: PropTypes.object,
    stepName: PropTypes.string,
    enquiry: PropTypes.object,
    onNext: PropTypes.func,
    onBack: PropTypes.func,
    onChangeEnquiry: PropTypes.func
};

export default BulkUploadOptions;
